<nav class="navbar navbar-expand-lg navbar-dark navbar-floating">
    <div class="container">
      <a class="navbar-brand" href="index.html">
        <img src="../assets/favicon-light.png" alt="" width="40">
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    
      <div class="collapse navbar-collapse" id="navbarToggler">
        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Home</a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="index.html">Homepage 1</a>
              <a class="dropdown-item" href="index-2.html">Homepage 2</a>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="about.html">About</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="blog.html">Blog</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" href="updates.html">What's New</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="contact.html">Contact</a>
          </li>
        </ul>
        <div class="ml-auto my-2 my-lg-0">
          <button class="btn btn-primary rounded-pill">Download Now</button>
        </div>
      </div>
    </div>
  </nav>
  
  
  <div class="bg-light">
  
  <div class="page-hero-section bg-image hero-mini" style="background-image: url(../assets/img/hero_mini.svg);">
    <div class="hero-caption">
      <div class="container fg-white h-100">
        <div class="row justify-content-center align-items-center text-center h-100">
          <div class="col-lg-6">
            <h3 class="mb-3 fw-medium">What's New</h3>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-dark justify-content-center bg-transparent">
                <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">Updates</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="page-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="card-page">
            <h3 class="mb-3">MindMilieu 10.0.3</h3>
   
            <p>iOS 10.0.3 includes improvements, bug fixes and additional parental controls for Screen Time.</p>
  
            <h5>Screen Time</h5>
            <ul class="theme-list">
              <li class="list-item">New parental controls provide more communication limits over who their children can call, FaceTime, or Message</li>
              <li class="list-item">Contact list for children lets parents manage the contacts that appear on their children’s devices</li>
            </ul>
   
            <h5>Apple News</h5>
            <ul class="theme-list">
              <li class="list-item">New layout for Apple News+ stories from The Wall Street Journal and other leading newspapers</li>
              <li class="list-item">Easily like or dislike stories with a tap</li>
            </ul>
            
            <h5>Stocks</h5>
            <ul class="theme-list">
              <li class="list-item">Stories from Apple News are now available in Canada in English and French</li>
              <li class="list-item">Continue reading with links to related stories or more stories from the same publication</li>
              <li class="list-item">“Breaking” and “Developing” labels for Top Stories</li>
            </ul>
  
            <p>This update also includes bug fixes and other improvements. This update:</p>
            <ul class="theme-list">
              <li class="list-item">Enables the creation of a new video clip when trimming a video in Photos</li>
              <li class="list-item">Adds support for NFC, USB, and Lightning FIDO2-compliant security keys in Safari</li>
              <li class="list-item">Fixes issues in Mail that may prevent downloading new messages</li>
              <li class="list-item">Addresses an issue that prevented deleting messages in Gmail accounts</li>
              <li class="list-item">Resolves issues that could cause incorrect characters to display in messages and duplication of sent messages in Exchange accounts</li>
              <li class="list-item">Fixes an issue where the cursor may not move after long pressing on the space bar</li>
              <li class="list-item">Addresses an issue that may cause screenshots to appear blurry when sent via Messages</li>
              <li class="list-item">Resolves an issue where cropping or using Markup on screenshots may not save to Photos</li>
              <li class="list-item">Fixes an issue where Voice Memos recordings may not be able to be shared with other audio apps</li>
              <li class="list-item">Addresses an issue where the missed call badge on the Phone app may not clear</li>
              <li class="list-item">Resolves an issue where the Cellular Data setting may incorrectly show as off</li>
              <li class="list-item">Fixes an issue that prevented turning off Dark Mode when Smart Invert was enabled</li>
              <li class="list-item">Addresses an issue where some wireless chargers may charge more slowly than expected</li>
            </ul>
            
            <p>For information on the security content of Apple software updates, please visit this website: <a href="https://support.apple.com/kb/HT201222 ">https://support.apple.com/kb/HT201222</a></p>
          </div>
  
          <div class="card-page mt-3">
            <h3 class="mb-3">MindMilieu 10.0.2</h3>
            <p>MindMilieu 10.0.2 includes bug fixes and improvements for your iPhone. This update:</p>
            <ul class="theme-list">
              <li class="list-item">Fixes an issue where system search and search within Mail, Files, and Notes might not work</li>
              <li class="list-item">Addresses an issue where photos, links, and other attachments might not display in the Messages details view</li>
              <li class="list-item">Fixes an issue that could prevent apps from downloading content in the background</li>
              <li class="list-item">Resolves issues that may prevent Mail from fetching new messages, and fail to include and quote original message content in Exchange accounts</li>
            </ul>
            <p>For information on the security content of Apple software updates, please visit this website:&nbsp;<a href="https://support.apple.com/kb/HT201222">https://support.apple.com/kb/HT201222</a>&nbsp;</p>
          </div>
  
          <div class="card-page mt-3">
            <h3>MindMilieu 10.0.1</h3>
            <p>iOS 10.0.1 includes bug fixes and improvements for your iPhone. This update:</p>
            <ul class="theme-list">
              <li class="list-item">Fixes an issue that could cause apps to quit unexpectedly when running in the background</li>
              <li class="list-item">Resolves an issue where iPhone may temporarily lose cellular service after a call</li>
              <li class="list-item">Addresses an issue where cellular data may temporarily not be available</li>
              <li class="list-item">Fixes an issue that caused replies to S/MIME encrypted email messages between Exchange accounts to be unreadable</li>
              <li class="list-item">Addresses an issue where using Kerberos single sign-on service in Safari may present an authentication prompt</li>
              <li class="list-item">Resolves an issue where charging may be interrupted on Yubikey Lightning-powered accessories</li>
            </ul>
            <p>For information on the security content of Apple software updates, please visit this website:&nbsp;<a href="https://support.apple.com/kb/HT201222">https://support.apple.com/kb/HT201222</a>&nbsp;</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  </div>
  
  
  <app-footer></app-footer>